import Error404Guard from '@src/components/guard/Error404Guard';
import SupportServicePreview from '@src/features/tenant/supportServices/SupportServicePreview';
import TenantPreviewLayout from '@src/layouts/tenant/TenantPreviewLayout';

function SupportServicePreviewForm() {
  return (
    <Error404Guard isTenant={true}>
      <TenantPreviewLayout>
        <SupportServicePreview />
      </TenantPreviewLayout>
    </Error404Guard>
  );
}
export default SupportServicePreviewForm;
